import { CanvasTexture, LinearFilter } from "three"
import { createOffscreenCanvas } from "../../canvas/create_canvas"
import { getCanvas2dContext } from "../../canvas/get_canvas_2d_context"
import { GameIcons_Delapouite_Square_d, GameIcons_Delapouite_Square_h, GameIcons_Delapouite_Square_w } from "../../svg/sprites_data_manual"

export default function createSquareCanvasTexture() {
  const canvas = createOffscreenCanvas(GameIcons_Delapouite_Square_w, GameIcons_Delapouite_Square_h)
  const ctx = getCanvas2dContext(canvas)

  if (ctx) {
    ctx.fillStyle = 'black'
    ctx.fill(GameIcons_Delapouite_Square_d)
  }

  // Create a texture
  const texture = new CanvasTexture(canvas)
  texture.minFilter = LinearFilter // Prevent mipmaps
  texture.needsUpdate = true

  // setDebugImageList((images) => [...images, canvas])

  return texture
}